import { useState } from "react";
import FormGenerator from "./FormGenerator";

interface Props{
    onChange: (val:any) => void;
}
const UndergradEducationalInfoForm:React.FC<Props> = ({onChange}) => {
    const [text,setText] = useState('');
    const [showScore, setShowScore] = useState(false);
    const [showGrad,setShowGrad] = useState(false);

    const handleUniChange=(cat:string)=>{
        if(cat === 'shs'){
            setText('What was your WASSCE score')
            setShowScore(true);
            setShowGrad(false);
        }
        else if(cat === 'uni'){
            setShowGrad(true);
        }

        onChange({isContinuingStudent:cat==='uni'?true:false})
    }

    const handleGradTypeChange=(cat:string)=>{
        if(cat === 'CWA'){
            setText('What is your current CWA')
            setShowScore(true);
        }
        else if(cat === 'GPA'){
            setText('What is your current GPA')
            setShowScore(true);
        }
        onChange({gradeType:cat});
    }

    const handleGradChange = (val:number) => {
        onChange({grade:val});

    }
    return(
        <div className="h-full w-full flex flex-col justify-center">
            <FormGenerator
                title='Educational Background'
                label='Are you a university continuing student or an SHS graduate?'
                type='select'
                onChange={handleUniChange}
                options={[
                    { label: 'Continuing Student', value: 'uni' },
                    { label: 'SHS Graduate', value: 'shs' },
                ]}
            />
            {
                showGrad &&
            <FormGenerator
                label='What is your grading system?'
                type='select'
                onChange={handleGradTypeChange}
                options={[
                    { label: 'CWA', value: 'CWA' },
                    { label: 'GPA', value: 'GPA' },
                ]}
            />
            }
            {
                showScore && 
            <FormGenerator
                label={text}
                type='number'
                onChange={handleGradChange}
            />
            }
        </div>
    )

}

export default UndergradEducationalInfoForm;